export const texts = {
    heading: 'Verificación de cobertura Tigo Hogar en tu zona',
    content: 'Revisaremos si hay cobertura en tu ubicación actual',
    subcontent: 'Si recibís una solicitud de ubicación, por favor elegí la opción "Permitir".',
    locationError: 'Para poder agregarte como nuevo cliente, debés activar el servicio de localización.'
}